import get from 'lodash.get';

const getPrices = (rootState) => get(rootState, 'products.prices', {});

export default getPrices;
